/* eslint-disable */
export { DateFormat } from '@/libs/utils';

const defaultStr = '--';

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

// 性别
export function gender_f(value) {
  let str = defaultStr;
  switch (+value) {
    case 2:
      str = '男';
      break;
    case 1:
      str = '女';
      break;
  }
  return str;
}

// 用户状态
export function userStatus_f(value) {
  let str = defaultStr;
  switch (+value) {
    case 1:
      str = '启用';
      break;
    case 0:
      str = '禁用';
      break;
  }
  return str;
}

// 发布状态
export function publishStatus(value) {
  const data = {
    0: '在库',
    1: '已发布',
    2: '待发布',
  };
  return data[+value] || defaultStr;
}

// 发布频道
export function publishChannel(value) {
  const data = {
    1: '中文',
    2: '英文',
    3: '日文',
  };
  return data[+value] || defaultStr;
}

// 发布频道
export function newsType(value) {
  const data = {
    1: '公司新闻',
    2: '行业资讯',
  };
  return data[+value] || defaultStr;
}

// 	产品状态 0:在库 1:已上架
export function categoryStatus(value) {
  const data = {
    0: '在库',
    1: '已上架',
  };
  return data[+value] || defaultStr;
}

// 	属性类型 0:在库 1:已上架
export function propertyType(value) {
  const data = {
    1: '图片',
    2: '文字',
    3: '文本域',
    4: '视频',
  };
  return data[+value] || defaultStr;
}

// 	多语言 1：是 0:否
export function isMultiLanguage(value) {
  const data = {
    1: '是',
    0: '否',
  };
  return data[+value] || defaultStr;
}
// 	必填 0：是 1:否
export function isRequired(value) {
  const data = {
    1: '否',
    0: '是',
  };
  return data[+value] || defaultStr;
}
// 	展示终端 0:公用 1:Web 2:H5
export function terminal(value) {
  const data = {
    0: '公用',
    1: 'Web',
    2: 'H5',
  };
  return data[+value] || defaultStr;
}terminal

// 	属性状态 1：是 0:否
export function propertyStatus(value) {
  const data = {
    1: '可见',
    0: '隐藏',
  };
  return data[+value] || defaultStr;
}

// 	属性状态 1：是 0:否
export function partnersType(value) {
  const data = {
    1: '主机厂',
    2: '合作伙伴',
    3: 'Tier1',
  };
  return data[+value] || defaultStr;
}

// 访问功能 1:首页 2:关于索菱 3:产品与服务 4:索菱能力 5:生产智造 6:资讯中心 7:投资者关系
export function browsingHistory(value) {
  const data = {
    1: '首页',
    2: '关于索菱',
    3: '产品与服务',
    4: '索菱能力',
    5: '生产智造',
    6: '资讯中心',
    7: '投资者关系',
  };
  return data[+value] || defaultStr;
}

export function imageShow(val) {
  const data = {
    1: '图片铺满',
    2: '图片居中',
  };
  return data[+val] || defaultStr;
}